import React from 'react';
import styled from 'styled-components';


const Container = styled.div`
  padding: 24px;
  text-align: center;
`;

const WelcomeTitle = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 16px;
`;

const WelcomeSubtitle = styled.p`
  font-size: 16px;
  color: #666;
  margin-bottom: 32px;
  line-height: 1.5;
`;

const HomePage: React.FC = () => {
  return (
    <Container>
      <WelcomeTitle>Fashion Connect</WelcomeTitle>
      <WelcomeSubtitle>
        AI destekli moda asistanınız. Size özel kombin önerileri ve stil danışmanlığı.
      </WelcomeSubtitle>
    </Container>
  );
};

export default HomePage;
